import { ObjectIcon } from '@carboncopyco/icons';
import {
  ContentEditableInput,
  TextBase,
  TextCaption,
  TextSubHeader,
} from '@carboncopyco/ui';
import type { ReactNode } from 'react';

type HeaderProps = {
  label: string;
  onTitleChange: (value: string) => void;
};

const Header = ({ label, onTitleChange }: HeaderProps) => {
  return (
    <div className="flex h-9 mt-4 px-4 items-center">
      <ContentEditableInput
        inputSize="xl"
        onChange={(display_name) => onTitleChange(display_name)}
      >
        <TextSubHeader
          ellipsis
          label={label}
          color="text-ds-natural-600"
        />
      </ContentEditableInput>
    </div>
  );
};

const SubHeader = ({ label }: { label: string }) => (
  <div className="flex h-9 mb-4 px-4 items-center">
    <TextCaption label={label} />
  </div>
);

const TopBar = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <div className="flex gap-4 h-9 mb-5 px-4 items-center justify-between">
    <div className="mr-auto">
      <TextBase
        label={label}
        color="text-ds-natural-600"
      />
    </div>

    {children}
  </div>
);

const Body = ({ children }: { children: ReactNode }) => (
  <div className="flex-1 flex flex-col min-h-0 mb-4 px-4">{children}</div>
);

type FooterProps = {
  modifiedCellsLabel: string;
  modifiedRowsLabel: string;
};

const Footer = ({ modifiedCellsLabel, modifiedRowsLabel }: FooterProps) => {
  return (
    <div className="flex items-center gap-1 h-ds-18 px-4 border-y border-solid text-ds-natural-300">
      <TextCaption
        label={
          <strong
            className="font-bold"
            aria-label="Total edits"
          >
            Total edits:
          </strong>
        }
        color="text-ds-natural-300"
      />
      <TextCaption
        label={modifiedCellsLabel}
        aria-label="Total cells edited"
        color="text-ds-natural-300"
      />
      <TextCaption
        label="|"
        color="text-ds-natural-300"
      />
      <div className="flex items-center gap-0.5">
        <div className="-my-2">
          <ObjectIcon size={13} />
        </div>
        <TextCaption
          label={modifiedRowsLabel}
          color="text-ds-natural-300"
        />
      </div>
    </div>
  );
};

export const ObjectDetails = ({ children }: { children: ReactNode }) => (
  <div className="h-full flex flex-col">{children}</div>
);

ObjectDetails.Header = Header;
ObjectDetails.SubHeader = SubHeader;
ObjectDetails.TopBar = TopBar;
ObjectDetails.Body = Body;
ObjectDetails.Footer = Footer;
